/* eslint-disable */
import $ from 'jquery';

var Form;

Form = (function (Form) {
  "use strict";

  Form.init = function () {
    Form.initListeners();
    Form.addTitleToOverflowingLabels();
  };

  Form.initListeners = function () {
    Form.initIntegratedLabelListeners();
    Form.initFocusListeners();
  };


  ////// INTEGRATED LABELS
  Form.initIntegratedLabelListeners = function () {
    $('.inputField').on('keydown keyup Form:UpdateLabel', '.inputField_input', Form.manageIntegratedLabel);
  };
  // Manage integrated labels
  Form.manageIntegratedLabel = function () {
    var $this = $(this);
    var $inputField = $this.closest('.inputField');

    $inputField.addClass('inputField-showLabel');
    if (!$this.val()) {
      $inputField.removeClass('inputField-showLabel');
    }
  };


  ////// FOCUS
  Form.initFocusListeners = function () {
    var $formField = $('.formField');
    $formField.on('focus', ':input', Form.addFocus);
    $formField.on('blur', ':input', Form.removeFocus);
  };
  Form.addFocus = function () {
    var $this = $(this);
    $this.closest('.formField').addClass('focus');
  };
  Form.removeFocus = function () {
    var $this = $(this);
    var $formField = $this.closest('.formField');

    if (!$this.is(':focus')) {
      $formField.removeClass('focus');
    }
  };

  // Enable Disable
  Form.disable = function (selector) {
    if (Array.isArray(selector)) {
      selector.forEach(function (selector) {
        Form.disable(selector);
      });
    } else {
      var $element = $(selector);
      $element.attr('disabled', 'disabled');
      $element.closest('.formField').addClass('disabled');
    }
  };

  Form.enable = function enable(selector) {
    if (Array.isArray(selector)) {
      selector.forEach(function (selector) {
        Form.enable(selector);
      });
    } else {
      var $element = $(selector);
      $element.removeAttr('disabled');
      $element.closest('.formField').removeClass('disabled');
    }
  };


  ///// OVERFLOWING LABELS
  Form.addTitleToOverflowingLabels = function () {
    $('.checkboxGroupField_label').each(function () {
      var element = $(this);

      if (this.offsetWidth < this.scrollWidth) {
        element.attr('title', element.text());
      }
    });
  };

  return Form;
}(Form || {}));

export default Form;
